import IAddress from "./IAddress";

export default class Address implements IAddress {
    constructor(
        public city: string = "",
        public country: string = "",
        public streetAddress: string = "",
        public streetNumber: string = "",
        public zip: string = "",
    ) {
    }
}
